import { Button, Checkbox, IconButton, Snackbar, TextField } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import irrImg from '../../../assets/auth-bg.svg';
import React, { useState } from 'react';
import { isEmpty, isValidPassword } from '../../../utils/functions/common.util';
import useAPI from '../../../hooks/useApi';
import CloseIcon from '@mui/icons-material/Close';

const ResetPasswordToken = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const { POST } = useAPI();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
                Ok
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const handleResetRequest = async () => {
        if (isEmpty(password)) {
            setError('Password is required');
            return;
        }
        if (!isValidPassword(password)) {
            setError('Password is invalid');
            return;
        }
        setLoading(true);
        console.log("Requesting Password:", { password });
        const resetPwrdPayload = {
            token,
            password
        }
        try {
            const response = await POST(`reset-password`, resetPwrdPayload);
            console.log("Response from password reset request:", response);
            navigate('/');
            if (response?.status) {
                // setSuccess(response.message);
                setMessage(response.message);
                setOpen(true);
            } else {
                setMessage(response.message);
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
        setError('');
    }

    return (
        <div className='flex h-screen p-2 bg-house-pattern bg-tr-white justify-center bg-no-repeat bg-center bg-cover bg-blend-color-burn items-center'>
            <img draggable="false" className='fixed top-auto' width={450} src={irrImg} alt="bg" />
            <div className='shadow z-10 px-5 pt-10 pb-20 m-auto w-full max-w-[30rem] bg-white text-center'>
                <h3 className='text-3xl font-bold text-austel-green mb-4'>Reset Password</h3>
                {/* <span className='text-gray-700 text-xs md:text-[14px] font-semibold block mb-6'>Please enter the email address you'd like your password reset information sent to</span> */}
                <CustomTextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!error}
                    helperText={error}
                />
                {loading ?
                    <button disabled className='mt-4 md:mt-6 text-white bg-austel-green py-2 px-20 my-2 block mx-auto text-xs md:text-base rounded mb-6 md:mb-8'>Loading...</button> :
                    <button onClick={handleResetRequest} className='mt-4 md:mt-6 text-white bg-austel-green py-2 px-20 my-2 block mx-auto text-xs md:text-base rounded mb-6 md:mb-8'>Reset Password</button>
                }
                {/* <Link className='text-austel-green font-[500]' to="/">Back To Login</Link> */}
            </div>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
                action={action}
            />
        </div>
    )
}

export default ResetPasswordToken


const CustomTextField = (props) => {
    const styles = {
        label: {
            fontSize: 14
        },
        inputP: {
            fontSize: 14,
            marginBottom: 10
        }
    }
    return <>
        <TextField
            variant='standard'
            end
            size='small'
            fullWidth
            InputLabelProps={{ style: styles.label }}
            InputProps={{
                style: styles.inputP
            }}
            {...props}
        />
    </>
}
